import { render } from "./BaseLayout.vue?vue&type=template&id=0923ac1c"
const script = {}

import exportComponent from "/var/www/kinetics/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__